import { render, staticRenderFns } from "./AccountChangeEmail.vue?vue&type=template&id=64280543&"
import script from "./AccountChangeEmail.vue?vue&type=script&lang=js&"
export * from "./AccountChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports